// Guards `:href` bindings that carry server-provided URLs. Vue does not block
// `javascript:`/`data:` in attribute bindings the way the server's HTML escaping
// does, so any external URL rendered from API data goes through this allowlist.
const SAFE_PROTOCOL = /^(https?:|mailto:)/i;

const DEL = 0x7f;
const LAST_CONTROL = 0x1f;

export function externalHref(url: string | undefined | null): string {
  if (!url) {
    return '#';
  }
  // Drop control chars (which browsers ignore) before matching, so a value like
  // "java\tscript:" cannot slip past the protocol allowlist; trim then handles
  // ordinary leading/trailing whitespace.
  const cleaned = Array.from(url)
    .filter((ch) => {
      const code = ch.charCodeAt(0);
      return code > LAST_CONTROL && code !== DEL;
    })
    .join('')
    .trim();
  return SAFE_PROTOCOL.test(cleaned) ? cleaned : '#';
}
